import React from 'react';

import CreateConfigPreset from '../CreateConfigPreset';
import { ICreateConfigPresetProps } from '../CreateConfigPreset/CreateConfigPreset';

function EditConfigPreset(props: ICreateConfigPresetProps) {
	return (
		<CreateConfigPreset
			{...props}
		/>
	);
}

export default EditConfigPreset;
